export const Order_status={
    pending:"pending",
    processing:"processing",
    invoice:"invoice",
    paid:"paid",
    return_vendor:"return",
    confirm_return_vendor:"confirm_return_vendor",
    }